import React from 'react'
import StepWrapper from '../StepStyled'
import styled from 'styled-components'

import {media} from 'utils/Media'


const SucessStyles = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  div {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    h4 {
      text-align: left;
      line-height: 2rem;
      color: black;
      @media ${media.ls} {
        line-height: 2.5rem;
      }
      @media ${media.md} {
        line-height: 3.5rem;
      }
    }
    
    .buttons {
      height: initial !important;
      position: initial !important;
    }

    button {
      background: none;
      margin-top: 2rem;
      border: none !important;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 200px !important;
      position: absolute;
      bottom: 1rem;
      right: 1rem;
      
       &:before {
        content: "";
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        border: solid ${(props) => props.theme.colors.primary} 2px;
        position: absolute;
        z-index: 1;
      }
      
      &:hover {
        &:before {
          border: solid ${(props) => props.theme.colors.primary} 4px;
        }
      }

      span {
        color: ${(props) => props.theme.colors.primary};
        line-height: 0;
      }
    }
  }

`
const StepTwo = props => {
    const {setOpen} = props
    return (
        <StepWrapper {...props} $successStep>
            <SucessStyles>
                <div>
                    <h5>THANKS FOR SIGNING UP.<br/>YOUR INFORMATION HAS BEEN SUBMITTED</h5>
                    <div className="buttons">
                        <button type="button" onClick={() => setOpen(false)}>
                            <span>CLOSE</span>
                        </button>
                    </div>
                </div>
            </SucessStyles>
        </StepWrapper>
    )
}

export default StepTwo
